import { useState, useRef, useEffect } from 'react';

import { Form } from 'antd';
import { Input as CInput, Popup } from 'antd-mobile';
import { Icon, Input, SearchOutlined, Space, Text } from 'farmhub-ui-core';

import { useAppDispatch, useAppSelector } from 'app';
import { NavbarMobile } from 'components/Layout/HeaderNavbar/HeaderMobile';
import {
  findProvincesAndDistricts,
  selectLocation,
  setDistrictSelect,
  setProvinceSelect,
} from 'slice';
import { theme } from 'styled';
import { removeVietnameseTones } from 'utils';

import { TabPanel, TabsMobile } from '../../Tabs';
import {
  Wrap,
  WrapError,
  WrapInput,
  WrapInputFullAddress,
  WrapTab,
} from './styles';

interface LocationSelectProps {
  form: any;
  provinceCodeInit: string;
  districtCodeInit: string;
  wardCodeInit: string;
  isVerticalForm?: boolean;
  marginBottom?: number;
  isLoadingAddress: boolean;
  isNotShowLabel?: boolean;
  hasErrorCode?: boolean;
  setHasErrorCode?: (e: boolean) => void;
  idPopup: string;
  height?: string;
}

const LocationSelectMobile = ({
  form,
  provinceCodeInit,
  districtCodeInit,
  wardCodeInit,
  isVerticalForm = false,
  isLoadingAddress = false,
  marginBottom = 24,
  isNotShowLabel,
  hasErrorCode,
  setHasErrorCode,
  idPopup,
  height = theme.select.height.md,
}: LocationSelectProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const provincesData = useAppSelector(
    state => state.location.provinceData
  ).filter(item => item.id !== 'all');
  const districtsData = useAppSelector(state => state.location.districtData);
  const isLoaded = useAppSelector(state => state.location.isLoaded);
  const wardsData = useAppSelector(state => state.location.wardData);
  const [provinceCodeSelected, setProvinceCodeSelected] = useState<string>();
  const [districtCodeSelected, setDistrictCodeSelected] = useState<string>();
  const [wardCodeSelected, setWardCodeSelected] = useState<string>();

  const [provinceNameSearch, setProvinceNameSearch] = useState<string>();
  const [districtNameSearch, setDistrictNameSearch] = useState<string>();
  const [wardNameSearch, setWardNameSearch] = useState<string>();

  const [provinceNameSelected, setProvinceNameSelected] = useState<string>();
  const [districtNameSelected, setDistrictNameSelected] = useState<string>();
  const [wardNameSelected, setWardNameSelected] = useState<string>();

  const [tabLocation, setTabLocation] = useState<string>('0');
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>();
  const [listAddress, setListAddress] = useState<any[]>([]);
  const [isNotShowLabelState, setIsNotShowLabelState] = useState<boolean>(
    isNotShowLabel || false
  );
  const [finishInput, setFinishInput] = useState<boolean>();

  const innerRef = useRef<HTMLDivElement>();
  const focusRef = useRef<HTMLDivElement>();

  const [latitude, setLatitude] = useState<string>('');
  const [longitude, setLongitude] = useState<string>('');
  const [address, setAddress] = useState<string>();
  const findLocation = useAppSelector(state => state.location.findLocation);
  const [isChangeTab, setIsChangeTab] = useState<boolean>(false);
  const location = useAppSelector(selectLocation);

  useEffect(() => {
    if (!provinceCodeSelected && !districtCodeSelected && !wardCodeSelected) {
      setSearchValue(undefined);
      setAddress(undefined);
    }
  }, [districtCodeSelected, provinceCodeSelected, wardCodeSelected]);

  useEffect(() => {
    let result = '';

    if (provinceCodeSelected) {
      const provinceResult = provincesData.find(
        item => Number(item.code) == Number(provinceCodeSelected)
      );

      if (provinceResult) {
        result += provinceResult.fullName;
        setProvinceNameSelected(provinceResult.fullName);
        const districtResult = districtsData?.find(
          item => Number(item.code) == Number(districtCodeSelected)
        );

        if (districtResult) {
          result = `${result}, ${districtResult.fullName}`;
          setDistrictNameSelected(districtResult.fullName);

          const wardResult = wardsData?.find(
            item => Number(item.code) == Number(wardCodeSelected)
          );
          if (wardResult) {
            result = `${result}, ${wardResult.fullName}`;
            setWardNameSelected(wardResult.fullName);

            if (finishInput) {
              setIsVisible(false);
              setHasErrorCode && setHasErrorCode(false);
              setFinishInput(false);
            }
          }
        }

        setAddress(result);
        setSearchValue('');
      }
    }
  }, [
    tabLocation,
    provinceCodeSelected,
    districtCodeSelected,
    wardCodeSelected,
  ]);

  useEffect(() => {
    // setAddress('');
    setListAddress([]);
    setProvinceCodeSelected('');
    setDistrictCodeSelected('');
    setWardCodeSelected('');

    if (isLoaded) {
      if (provinceCodeInit) {
        dispatch(setProvinceSelect(provinceCodeInit));
        setProvinceCodeSelected(provinceCodeInit);
        setTabLocation('1');
      } else {
        setTabLocation('0');
      }

      if (provinceCodeInit && districtCodeInit) {
        setTabLocation('2');

        dispatch(
          setDistrictSelect({
            districtCode: districtCodeInit,
            provinceCode: provinceCodeInit,
          })
        );

        form.setFieldsValue({
          districtCode: districtCodeInit,
          provinceCode: provinceCodeInit,
          wardCode: wardCodeInit,
        });

        setDistrictCodeSelected(districtCodeInit);
        setWardCodeSelected(wardCodeInit);
      }
    }
  }, [isLoaded, provinceCodeInit, districtCodeInit, isLoadingAddress]);

  useEffect(() => {
    if (findLocation) {
      form.setFieldsValue({
        address: findLocation.address,
        provinceCode: findLocation.provinceCode,
        districtCode: findLocation.districtCode,
        wardCode: findLocation.wardCode,
        latitude: findLocation.latitude,
        longitude: findLocation.longitude,
      });

      setProvinceCodeSelected(findLocation.provinceCode);
      setDistrictCodeSelected(findLocation.districtCode);
      setWardCodeSelected(findLocation.wardCode);
    }
  }, [isLoadingAddress]);

  const handleSelectProvince = (value: string) => {
    let result = value;
    if (result.length == 1) {
      result = `0${value}`;
    }

    setProvinceCodeSelected(result);

    form.setFieldsValue({
      provinceCode: result,
      districtCode: null,
      wardCode: null,
    });

    setProvinceCodeSelected(result);
    setDistrictCodeSelected('');
    setTabLocation('1');
    dispatch(setProvinceSelect(result));
  };
  const handleSelectDistrict = (value: string) => {
    if (provinceCodeSelected && value) {
      let result = value;

      if (result.length == 2) {
        result = `0${value}`;
      } else if (result.length == 1) {
        result = `00${value}`;
      }

      form.setFieldsValue({
        provinceCode: provinceCodeSelected,
        districtCode: result,
        wardCode: null,
      });

      dispatch(
        setDistrictSelect({
          districtCode: result,
          provinceCode: provinceCodeSelected,
        })
      );

      setTabLocation('2');
      setDistrictCodeSelected(result);
      setWardCodeSelected('');
    }
  };

  const handleSelectWard = (value: string) => {
    if (provinceCodeSelected && districtCodeSelected) {
      let result = value;
      if (result?.length == 4) {
        result = `0${value}`;
      } else if (result?.length == 3) {
        result = `00${value}`;
      } else if (result?.length == 2) {
        result = `000${value}`;
      } else if (result?.length == 1) {
        result = `0000${value}`;
      }

      form.setFieldsValue({
        provinceCode: provinceCodeSelected,
        districtCode: districtCodeSelected,
        wardCode: result,
      });

      setTabLocation('0');
      setWardCodeSelected(result);
      setFinishInput(true);
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', e => {
      const ref: any = innerRef.current;

      if (!ref?.contains(e.target)) {
        // setIsVisible(false);
        // put your action here
      }
    });
  });

  useEffect(() => {
    const initLocationData = async () => {
      try {
        await dispatch(findProvincesAndDistricts()).unwrap();
      } catch (error) {
        console.log('An error occurred while finding locations', error);
      }
    };

    if (!location?.isLoaded && location.data?.length == 0) {
      initLocationData();
    }
  }, [dispatch, location.data?.length, location?.isLoaded]);

  const tabItems = [
    {
      key: '0',
      title: `${
        provinceCodeSelected && provinceNameSelected
          ? provinceNameSelected
          : 'Tỉnh thành'
      }`,
      components: (
        <>
          <WrapInput>
            <Input
              background="#f8f8f8"
              height="50px"
              placeholder="Tỉnh thành"
              prefix={
                <Icon>
                  <SearchOutlined style={{ fontSize: '16px' }} />
                </Icon>
              }
              styles={{ border: '0px' }}
              value={provinceNameSearch}
              width="100%"
              onChange={e => {
                setProvinceNameSearch(e.target.value);
              }}
              onFocus={() => setIsVisible(true)}
            />
          </WrapInput>
          <WrapTab>
            <Form.Item name="provinceCode">
              <ul className="wrap-ul">
                {provincesData
                  ?.filter((item: any) => {
                    if (provinceNameSearch) {
                      return removeVietnameseTones(
                        item.fullName.toLowerCase()
                      ).includes(
                        removeVietnameseTones(provinceNameSearch.toLowerCase())
                      );
                    }
                    return true;
                  })
                  ?.map((province: any) => (
                    // eslint-disable-next-line react/button-has-type
                    <button
                      key={province.code}
                      className={
                        province.code == provinceCodeSelected ? 'active' : ''
                      }
                      type="button"
                      value={province.code}
                      onClick={e => {
                        setIsChangeTab(!isChangeTab);
                        handleSelectProvince(
                          String((e.target as HTMLInputElement).value)
                        );
                      }}
                    >
                      {isVerticalForm ? province.fullName : province.name}
                    </button>
                  ))}
              </ul>
            </Form.Item>
          </WrapTab>
        </>
      ),
    },
    {
      key: '1',
      title: `${
        districtCodeSelected && districtNameSelected
          ? districtNameSelected
          : 'Quận huyện'
      }`,
      components: (
        <>
          <WrapInput>
            <Input
              background="#f8f8f8"
              height="46px"
              placeholder="Quận Huyện"
              prefix={
                <Icon>
                  <SearchOutlined style={{ fontSize: '16px' }} />
                </Icon>
              }
              styles={{ border: '0px' }}
              value={districtNameSearch}
              width="100%"
              onChange={e => {
                setDistrictNameSearch(e.target.value);
              }}
              onFocus={() => setIsVisible(true)}
            />
          </WrapInput>

          <WrapTab>
            <Form.Item name="districtCode">
              <ul className="wrap-ul">
                {districtsData
                  ?.filter((item: any) => {
                    if (districtNameSearch) {
                      return removeVietnameseTones(
                        item.fullName.toLowerCase()
                      ).includes(
                        removeVietnameseTones(districtNameSearch.toLowerCase())
                      );
                    }
                    return true;
                  })
                  ?.map((district: any) => (
                    // eslint-disable-next-line react/button-has-type
                    <button
                      key={district.code}
                      className={
                        district.code == districtCodeSelected ? 'active' : ''
                      }
                      type="button"
                      value={district.code}
                      onClick={e => {
                        setIsChangeTab(!isChangeTab);
                        handleSelectDistrict(
                          String((e.target as HTMLInputElement).value)
                        );
                      }}
                    >
                      {district.fullName}
                    </button>
                  ))}
              </ul>
            </Form.Item>
          </WrapTab>
        </>
      ),
    },
    {
      key: '2',
      title: `${
        wardCodeSelected && wardNameSelected ? wardNameSelected : 'Xã phường'
      }`,
      components: (
        <>
          {' '}
          <WrapInput>
            <Input
              background="#f8f8f8"
              height="46px"
              placeholder="Xã phường"
              prefix={
                <Icon>
                  <SearchOutlined style={{ fontSize: '16px' }} />
                </Icon>
              }
              styles={{ border: '0px' }}
              value={wardNameSearch}
              width="100%"
              onChange={e => setWardNameSearch(e.target.value)}
              onFocus={() => setIsVisible(true)}
            />
          </WrapInput>
          <WrapTab>
            <Form.Item name="wardCode">
              <ul className="wrap-ul">
                {wardsData
                  ?.filter((item: any) => {
                    if (wardNameSearch) {
                      return removeVietnameseTones(
                        item.fullName.toLowerCase()
                      ).includes(
                        removeVietnameseTones(wardNameSearch.toLowerCase())
                      );
                    }
                    return true;
                  })
                  ?.map((ward: any) => (
                    // eslint-disable-next-line react/button-has-type
                    <button
                      key={ward.code}
                      className={ward.code == wardCodeSelected ? 'active' : ''}
                      type="button"
                      value={ward.code}
                      onClick={e => {
                        handleSelectWard(
                          String((e.target as HTMLInputElement).value)
                        );
                      }}
                    >
                      {ward.fullName}
                    </button>
                  ))}
              </ul>
            </Form.Item>
          </WrapTab>
        </>
      ),
    },
  ];

  return (
    <>
      <Wrap>
        {!isNotShowLabel && (
          <>
            <Text size="xs" style={{ paddingBottom: '8px' }} weight="bold">
              <Text color="red">*</Text> Tỉnh thành/Quận huyện/Xã phường
            </Text>
            <Space height={8} />
          </>
        )}
        <WrapInputFullAddress>
          <CInput
            ref={focusRef as any}
            placeholder="Tỉnh thành/Quận huyện/Xã phường"
            style={{
              width: '100%',
              height,
              border: '1px solid #d9d9d9',
              fontSize: '14px',
              borderRadius: '6px',
            }}
            value={address || searchValue}
            onFocus={e => {
              focusRef?.current && focusRef?.current?.blur();
              setIsVisible(true);
            }}
          />
        </WrapInputFullAddress>

        {hasErrorCode && (
          <WrapError>Vui lòng nhập đầy đủ thông tin tỉnh, huyện, xã!</WrapError>
        )}
      </Wrap>
      <Popup
        bodyStyle={{
          height: '100vh',
          padding: '0px 0px 18px 0px',
          fontSize: '14px !important',
          position: 'fixed',
          top: 0,
          left: 0,
        }}
        getContainer={() =>
          document.getElementById('create-update-location') as HTMLElement
        }
        style={{
          zIndex: 1300,
        }}
        visible={isVisible}
        onMaskClick={() => {
          setIsVisible(false);
        }}
      >
        <NavbarMobile
          handleBack={() => setIsVisible(false)}
          style={{ position: 'sticky' }}
          title="Địa chỉ"
        />
        <TabsMobile
          heightTop={60}
          isChangeTab={isChangeTab}
          tabLocation={Number(tabLocation)}
        >
          {tabItems.map(item => (
            <TabPanel
              key={item.key}
              style={{
                paddingBottom: '18px',
              }}
              tab={item.title}
            >
              {item.components}
            </TabPanel>
          ))}
        </TabsMobile>
      </Popup>
    </>
  );
};

export default LocationSelectMobile;
